/**
 * Utilitaire de compression d'images
 * Réduit la taille des images avant upload sans perte de qualité visible
 */

export const compressImage = (file, options = {}) => {
  const {
    maxWidth = 1920,
    maxHeight = 1080,
    quality = 0.8,
    maxSizeMB = 1
  } = options;

  return new Promise((resolve, reject) => {
    // Si le fichier est déjà petit, ne pas compresser
    if (file.size < maxSizeMB * 1024 * 1024) {
      resolve(file);
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let { width, height } = img;
        
        // Calculer les nouvelles dimensions
        if (width > maxWidth) {
          height = (height * maxWidth) / width;
          width = maxWidth;
        }
        if (height > maxHeight) {
          width = (width * maxHeight) / height;
          height = maxHeight;
        }
        
        canvas.width = width;
        canvas.height = height;
        
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        
        // Convertir en blob
        canvas.toBlob(
          (blob) => {
            if (blob) {
              // Créer un nouveau fichier avec le même nom
              const compressedFile = new File([blob], file.name, {
                type: 'image/jpeg',
                lastModified: Date.now()
              });
              
              console.log(`Image compressée: ${(file.size / 1024).toFixed(1)}KB -> ${(compressedFile.size / 1024).toFixed(1)}KB`);
              resolve(compressedFile);
            } else {
              resolve(file); // Fallback au fichier original
            }
          },
          'image/jpeg',
          quality
        );
      };
      
      img.onerror = () => reject(new Error('Erreur de chargement de l\'image'));
    };
    
    reader.onerror = () => reject(new Error('Erreur de lecture du fichier'));
  });
};

/**
 * Compresse une image et retourne un FormData prêt pour l'upload
 */
export const prepareImageUpload = async (file, fieldName = 'file') => {
  try {
    const compressedFile = await compressImage(file);
    const formData = new FormData();
    formData.append(fieldName, compressedFile);
    return formData;
  } catch (error) {
    console.error('Erreur de compression:', error);
    // Fallback: utiliser le fichier original
    const formData = new FormData();
    formData.append(fieldName, file);
    return formData;
  }
};
